<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            Biz haqimizda
          </h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(storeData)"
                    class="form form-horizontal">
                <div class="form-body">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label for="upload-picture-large">Asosiy rasm</label>
                        </div>
                        <div class="col-md-9">
                          <div class="position-relative has-icon-left">
                            <div class="vs-checkbox-con vs-checkbox-primary">
                              <div id="upload-picture-large">
                                <upload-image
                                    :browseText="''"
                                    :data-images="largeImages"
                                    :disabled="loading"
                                    :dragText="'Rasmni yuklash'"
                                    :multiple="false"
                                    :popup-text="'Katta rasm'"
                                    :primaryText="'katta rasm'"
                                    @before-remove="beforeRemovePictureLarge"
                                    @edit-image="editPictureLarge"
                                    @upload-success="uploadPictureLargeSuccess"
                                    editUpload="productUpdateEditId"
                                    idUpload="filePictureLarge"/>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label for="name">Sarlavha <span
                              class="text-danger">*</span></label>
                        </div>
                        <div class="col-md-9">
                          <ValidationProvider name="Kurs nomlanishi" rules="required"
                                              v-slot="{ errors }">
                            <div class="position-relative has-icon-left">
                              <input :disabled="loading" class="form-control" id="name"
                                     name="fname-icon" placeholder="Kurs nomlanishi"
                                     type="text"
                                     v-model="dataObject.title">
                            </div>
                            <span class="text-danger" v-if="errors.length > 0">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label>Kontent</label>
                        </div>
                        <div class="col-md-9">
                          <div class="position-relative has-icon-left">
                            <!--           <ckeditor
                                               :disabled="loading"
                                               :editor="editor"
                                               v-model="dataObject.content"
                                       />-->
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">

                          <button :disabled="loading" class="btn btn-info waves-effect waves-light"
                                  type="submit"
                                  v-if="successMessage === ''">
                                                        <span aria-hidden="true"
                                                              class="spinner-border spinner-border-sm"
                                                              role="status"
                                                              v-if="loading"/>
                            Saqlash
                          </button>
                          <button class="btn btn-success mr-1" disabled="disabled"
                                  type="button"
                                  v-else>
                            <i class="feather icon-check"/>
                            {{ successMessage }}
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <a class="d-none" href="#" ref="anchor"/>
  </div>
</template>

<script>

import {extend, ValidationObserver, ValidationProvider} from 'vee-validate';
import {required} from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Kiriting {_field_}'
});

export default {
  name: "Form",
  data() {
    return {
      largeImages: [],
      dataObject: {},
      loading: false,
      successMessage: '',
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider
  },
  methods: {
    storeData() {
      this.loading = true;
      this.$api.post('admin/Course/insert', this.formData())
          .then(res => {
            if (!res.error) {
              this.succMessage('Сохранено');
            } else {
              this.notificationMessage(res.error, 'error');
            }
          })
          .catch(err => {
            this.notificationMessage('Ошибка', 'error');
          })
          .finally(() => {
            this.loading = false;
          })
    },

    getData() {
      this.$api.get(`admin/`)
          .then(res => {
            if (!res.error && res.statusCode === 200) {
              this.dataObject = res.result;
            }
          })
    },

    createCourseObject(course = null) {
      return {
        title: '',
        content: '',
        image: null,
      };
    },
    formData() {
      let form = new FormData();
      for (let prop in this.course)
        form.append(prop, this.course[prop]);

      return form;
    },
    uploadPictureLargeSuccess(formData, index, fileList) {
      this.dataObject.image = formData.get('file');
    },
    beforeRemovePictureLarge(index, done, fileList) {
      if (this.dataObject.image) {
        this.deleteStoredImage(this.dataObject.image);
        this.dataObject.image = null;
        this.dataObject.image = null;
      }
      done()
    },
    editPictureLarge(formData, index, fileList) {
      this.largeImages = [];
      this.dataObject.imageFormData = formData;
      this.dataObject.image = null;
    },

    async deleteStoredImage(imageName) {
      let params = {};
      params.photo = imageName;
      return this.$api.post('file-uploads/delete-image', params).then(res => {
        if (res) {
          return res;
        } else {
          return false;
        }
      }).catch(error => {
        return false;
      }).finally(item => {
        ///
      });
    },

    succMessage(successMessage) {
      this.successMessage = successMessage;
      this.notificationMessage(successMessage, 'success');
      setTimeout(() => {
        this.successMessage = '';
      }, 1000);
    },
  },

  created() {

  },
}
</script>


<style scoped>

</style>